import React from 'react'
import {Redirect} from 'react-router-dom'
import Dialog from 'material-ui-legacy/Dialog'
import Snackbar from 'material-ui-legacy/Snackbar'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import DoneButton from '../UI/DoneButton'
import ClientForm from './ClientForm'
import ClientCard from './ClientCard'

import Resource from '../../stores/resource'
const ClientStore = Resource('clients')

class NewClient extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      client: (this.props.attributes || {}),
      saved: false,
      error: '',
      snackbarMessage: '',
      redirect: null
    }
  }

  _save = (attributes) => {
    ClientStore.create(attributes)
    .then((result) => {
      this.setState({
        saved: true,
        error: '',
        savedClient: result.data.data,
        snackbarMessage: `Client "${attributes.name}" created!`
      },
      () => {
        if (this.props.savedCallback) { this.props.savedCallback(this.state.savedClient)
        }
      })
    })
    .catch(
      (error) => this.setState({saved: false, error: errors.unpack(error)})
    )
  }

  _closeErrorDialog = () => this.setState({error: ''})

  _closeSuccessDialog = () => this.setState({redirect: `/clients`})

  _resetSnackbar = () => this.setState({snackbarMessage: ''})

  _redirectTo = (url) => this.setState({redirect: url})

  render() {
    if (this.state.redirect) return <Redirect push to={this.state.redirect}/>

    const client = this.state.client
    const saved = this.state.saved

    const successDialogActions = [
      <DoneButton onTouchTap={this._closeSuccessDialog}/>
    ]

    return (
      <section>
        <ClientForm
          formTitle={this.props.formTitle}
          code={client.code}
          name={client.name}
          phone={client.phone}
          address={client.address}
          city={client.city}
          province={client.province}
          country={client.country}
          postalCode={client.postalCode}
          forceChanged={this.props.forceChanged}
          submitCallback={this._save}
          cancelCallback={this.props.cancelCallback}
        />
        <br/>

        <ErrorDialog
          open={Boolean(this.state.error)}
          closeCallback={this._closeErrorDialog}
          title="Couldn't create client">
          <p>
            <strong>Error:</strong> {this.state.error}
          </p>
        </ErrorDialog>

        <Snackbar
          open={Boolean(this.state.snackbarMessage)}
          message={this.state.snackbarMessage}
          autoHideDuration={4000}
          onRequestClose={this._resetSnackbar}
        />

        {/* Success dialog */}
        {saved && this.props.showSuccessDialog &&
          <Dialog
            actions={successDialogActions}
            modal={false}
            onRequestClose={this._closeSuccessDialog}
            open={Boolean(this.state.saved)}
            title="Client created">
            <p>
              A new client has been created with the information below.<br/>
              If you see any incorrect information, press the <strong>Edit</strong> button.
            </p>
            <ClientCard
              client={this.state.savedClient}
              editCallback={() => this._redirectTo(`/clients/${this.state.savedClient.id}/edit`)}
            />
          </Dialog>
        }
      </section>
    )
  }
}

export default NewClient



// WEBPACK FOOTER //
// ./src/components/Clients/NewClient.jsx